import { FC, HTMLAttributes } from "react";

const StatsOutsideCell: FC<HTMLAttributes<HTMLDivElement>> = ({
    children,
    className,
    ...rest
}) => {
    return (
        <div
            {...rest}
            className={className}
            style={{
                backgroundColor: "var(--surface-muted)",
                border: "1px solid var(--border-color)",
                borderRadius: "6px",
                boxSizing: "border-box",
                color: "var(--text-muted)",
            }}
        />
    );
};

export default StatsOutsideCell;
